// external imports
import React from 'react'
import { FlexRow, FlexColumn } from 'quark-web'
import { Link } from 'react-router-dom'
// local imports
import styles from './styles'
import { Text } from '~/components'
import './responsive.css'

const Offline = () => (
    <FlexRow style={styles.container} alignItems="center" justifyContent="center">
        <FlexRow justifyContent="flex-end" style={styles.content}>
        </FlexRow>
    </FlexRow>
)

const FooterLink = ({ children, style, ...unused }) => (
    <Link {...unused}>
        <Text style={style}>
            {children}
        </Text>
    </Link>
)

const ContactInfo = [
    {
        name: 'Lark Seeds INTL',
        address: '115 W. California BL #197\nPasadena, CA 91105',
        phoneNumber: '+1 (626) 396-9018',
        email: 'info@larkseeds.com'
    }, {
        name: 'Semillas Lark SA DE CV',
        address: 'Los Mochis - Culiacán, 80375\nSinaloa., Mexico',
        phoneNumber: '+52 46 11 16 92 48',
        email: 'lsmexico@larkseeds.com'
    }, {
        name: 'Lark Seeds Canada',
        address: '859 Talbot Trail E Wheatley\nON NOP 2P0 CANADA',
        phoneNumber: '+1 (519) 8257218',
        email: 'info@larkseeds.com'
    }, {
        name: 'Lark Seeds Hellas',
        address: 'Geor. Papandreou 107\nMetamorfosi 144 52 Greece',
        phoneNumber: '+30 210 283 7242',
        email: 'lshellas@larkseeds.com'
    }, {
        name: 'Lark Seeds Turkey',
        address: 'Termesos Blv\nOfis 24 iş Mrk. No:18-A2 Kat:4/8\n07300 Muratpaşa/Antalya, Turkey',
        phoneNumber: '+90 532 386 66 57',
        email: 'lsturkey@larkseeds.com'
    }
]

// Eventually this should be used to have geo-selection. For now it will default to
// having only Lark ITL on mobile page load, and elsewise multiple based on screen size.
function getContacts(ContactInfo) {
    let width = screen.width;
    if (width < 768) {
        return [ContactInfo[0]]
    }
    else if (width < 1024) {
        return [ContactInfo[0], ContactInfo[1], ContactInfo[3]]
    }
    return ContactInfo
}
var selectedContacts = getContacts(ContactInfo);


const Contact = () => (
    <div className={'contact'}>
        {selectedContacts.map(function (d, idx) {
            return (
                <FlexColumn style={styles.column} key={d.name}>
                    <FooterLink to="/company" style={styles.headerItem}>{d.name}</FooterLink>
                    <Text style={styles.footerItem}>{d.address}</Text>
                    <Text style={styles.footerItem}>{d.phoneNumber}</Text>
                    <FooterLink to={"mailto:" + d.email} target="_blank" style={styles.footerItem}>{d.email}</FooterLink>
                </FlexColumn>
            )
        })}
    </div>
)

const Footer = () => (
    <FlexColumn style={styles.container}>
        <Contact />
        <FlexRow justifyContent="center">
            <Text style={styles.copyright}>© 2025, Lark Seeds</Text>
        </FlexRow>
    </FlexColumn>

)

export default Footer



// WEBPACK FOOTER //
// ./src/views/Root/Footer/index.js